const routeJackpot = () => '/jackpot';

export default routeJackpot;
